import axios from "axios";
import { getBaseUrl } from "../environment-url";
import { setLogout } from "../../store/authReducer";
import { logoutSession } from "../../hooks/hook";

const TOKEN_API = axios.create({
    baseURL: getBaseUrl(process.env.REACT_APP_NODE_ENV, "TOKEN_URL"),
    responseType: "json",
    withCredentials: false,
    timeout: 10000, // 10 seconds
});

TOKEN_API.interceptors.response.use(
    (response) => {
        console.log('response');

        return response;
    },
    (error) => {
        if (error.response && error.response.status === 401) {
            console.log("*********** Unauthorized Error **********");
            logoutSession();
        }
        return Promise.reject(error);
    }
)

export default TOKEN_API;
